<template>
  <section>
    <b-modal
      :visible="visible"
      hide-footer
      button-size="sm"
      size="xl"
      modal-cancel="false"
      no-close-on-backdrop
      @close="close"
      id="credit-transaction-list-modal"
    >
      <template v-slot:modal-title
        >Transacciones de pensiones adelantadas</template
      >
      <section class="container-fluid">
        <div class="row">
          <div class="col-9">
            <template v-if="student.id != 0">
              <span>
                <b>Estudiante:</b>
                {{ student.person.last_name }}
                {{ student.person.first_name }}
                <b>Crédito:</b>
                Bs. {{ student.credit | currency }}
              </span>
            </template>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-12 float-right">
                <div class="card-header-actions">
                  <b-button
                    @click="modalAddCreditTransaction()"
                    variant="success"
                    size="sm"
                    title="Pago de pensiones adelantadas"
                  >
                    <CIcon size="sm" name="cil-plus" />
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CDataTable
          class="table-bordered c-table c-table-main"
          :hover="true"
          :striped="true"
          :bordered="true"
          :small="true"
          :items="items"
          :fields="fields"
          :sorter="{ external: true, resetable: true }"
          @update:sorter-value="filterTable"
          :columnFilter="{ external: true, lazy: true }"
          @update:column-filter-value="filterTable"
          :column-filter-value.sync="columnFilter"
          :loading="loading"
        >
          <template #no-items-view>
            <div class="no-items-view">
              {{
                loading ? "Cargando datos..." : "No existen cursos programados"
              }}
              <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
            </div>
          </template>
          <!-- filters -->
          <template #annulled-filter>
            <b-form-select
              v-model="columnFilter.annulled"
              :options="annulledOptions"
              value-field="code"
              text-field="label"
              id="annulled"
              size="sm"
              @change="filterTable"
            >
            </b-form-select>
          </template>
          <template #detail-filter>
            <b-button
              @click="reload"
              variant="secondary"
              size="sm"
              title="Recargar tabla"
            >
              <CIcon size="sm" name="cil-reload" />
            </b-button>
            <b-button
              @click="clean"
              variant="secondary"
              size="sm"
              title="Limpiar filtros"
            >
              <CIcon size="sm" name="cil-filter-x" />
            </b-button>
          </template>
          <!-- data -->
          <template #id="{ index }">
            <td>{{ (page - 1) * limit + (index + 1) }}</td>
          </template>
          <template #transaction_type="{ item }">
            <td>
              {{ item.transaction_type == "CREDIT" ? "CRÉDITO" : "DÉBITO" }}
            </td>
          </template>
          <template #created_at="{ item }">
            <td>
              {{ item.created_at }}
            </td>
          </template>

          <template #monto="{ item }">
            <td class="text-right">
              {{
                (item.transaction_type == "CREDIT"
                  ? item.total_credit
                  : -1 * item.total_debit) | currency
              }}
            </td>
          </template>

          <template #total_balance="{ item }">
            <td class="text-right">
              {{ item.total_balance | currency }}
            </td>
          </template>

          <template #payment_method_id="{ item }">
            <td>
              {{ item.payment_method_id | payment_method }}
            </td>
          </template>

          <template #annulled="{ item }">
            <td>
              <CBadge color="danger" v-if="item.annulled == true"
                >Anulado</CBadge
              >
              <CBadge color="success" v-else>Activo</CBadge>
            </td>
          </template>

          <template #detail="{ item }">
            <td>
              <b-button-group size="xs">
                <!-- anular -->
                <b-button
                  v-if="
                    item.id == rowToAnnulled.id &&
                    item.total_credit <= student.credit &&
                    item.payment_method_id !== 7
                  "
                  variant="danger"
                  title="Anular"
                  @click="modalAnnulled(item.id)"
                >
                  <CIcon size="sm" name="cil-x-circle" />
                </b-button>
                <!-- pdf -->
                <button
                  v-if="
                    item.annulled == false &&
                    item.transaction_type == 'CREDIT' &&
                    item.payment_method_id !== 7
                  "
                  @click="showIndividualPdf(item.id)"
                  title="Recibo de pago"
                  class="btn btn-secondary btn-sm"
                  type="button"
                >
                  <span><CIcon size="sm" name="cil-file" /></span>
                </button>
              </b-button-group>
            </td>
          </template>
        </CDataTable>
        <div>
          <CPagination
            :activePage.sync="page"
            :pages="pages"
            size="sm"
            align="center"
            @update:activePage="updateTable"
          />
          <TableRecords
            :total="total"
            :loading="loading"
            :from="from"
            :to="to"
            :page="page"
          />
        </div>
      </section>
    </b-modal>
    <section v-if="modShowAddCreditTransaction">
      <CreditTransactionAddModal
        :student_id="student.id"
        :customer_id="student.customer_id"
        :modShowAddCreditTransaction="modShowAddCreditTransaction"
        @creditTransactionAdd="afterCreditTransactionAdd"
      ></CreditTransactionAddModal>
    </section>
    <section v-if="modShowAnnCreditTransaction">
      <CreditTransactionAnnulledModal
        :credit_transaction_id="credit_transaction_id"
        :modShowAnnCreditTransaction="modShowAnnCreditTransaction"
        @creditTransactionAnnulled="afterCreditTransactionAnnulled"
      ></CreditTransactionAnnulledModal>
    </section>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CreditTransactions from "@/plugins/services/credit-transactions";
import Students from "@/plugins/services/students";
// components
import CreditTransactionAddModal from "@/entities/credit-transactions/CreditTransactionAddModal";
import CreditTransactionAnnulledModal from "@/entities/credit-transactions/CreditTransactionAnnulledModal";

export default {
  name: "CreditTransactionsListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    TableRecords,
    CreditTransactionAddModal,
    CreditTransactionAnnulledModal,
  },
  props: {
    modShowCreditTransactionList: { type: Boolean, required: true },
    student_id: { type: Number, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "created_at",
          label: "Fecha",
          sorter: false,
          filter: false,
          _style: "min-width:130px;",
        },
        {
          key: "code_number",
          label: "Código",
          sorter: false,
          _style: "width: 10%;",
        },
        {
          key: "observation",
          sorter: false,
          label: "Observación",
        },
        {
          key: "transaction_type",
          label: "Tipo",
          sorter: false,
          filter: false,
          _style: "width: 10%;",
        },
        {
          key: "monto",
          label: "Monto",
          sorter: false,
          filter: false,
          _style: "width: 8%;",
        },
        {
          key: "total_balance",
          label: "Balance total",
          sorter: false,
          filter: false,
          _style: "width: 8%;",
        },
        {
          key: "payment_method_id",
          label: "Método de pago",
          sorter: false,
          filter: false,
          _style: "width: 15%;",
        },
        {
          key: "annulled",
          label: "Anulado",
          sorter: false,
          filter: false,
          _style: "width: 6%;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      student: {
        id: 0,
        customer_id: null,
      },
      items: [],
      columnFilter: {
        asc: true,
        enabled: true,
        annulled: false,
      },
      annulledOptions: Constants.annulledOptions,
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null, transactionMade: false },
      credit_transaction_id: 0,
      modShowAddCreditTransaction: false,
      modShowAnnCreditTransaction: false,
      rowToAnnulled: {
        id: null,
        total_credit: 0,
      },
    };
  },
  mounted() {
    this.columnFilter.student_id = this.student_id;
    this.getStudent(this.student_id);
    this.getAll(this.columnFilter);
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowCreditTransactionList;
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      CreditTransactions.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
        this.rowToAnnulled = res.data.row_to_annulled;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        student_id: this.student_id,
        asc: true,
        annulled: false,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter, this.page);
    },
    getStudent(id) {
      Students.getOne(id)
        .then((res) => {
          this.student = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.closeModal();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal();
          }
          this.dataLoader = false;
        });
    },
    modalAddCreditTransaction() {
      this.modShowAddCreditTransaction = true;
    },
    afterCreditTransactionAdd(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.dataEmit.transactionMade = true;
        this.reload();
        this.getStudent(this.student.id);
        this.showIndividualPdf(response.data.id);
      }
      this.modShowAddCreditTransaction = response.modalShow;
    },
    modalAnnulled(id) {
      this.credit_transaction_id = id;
      this.modShowAnnCreditTransaction = true;
    },
    afterCreditTransactionAnnulled(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.dataEmit.transactionMade = true;
        this.reload();
        this.getStudent(this.student.id);
      }
      this.modShowAnnCreditTransaction = response.modalShow;
    },
    closeModal(data = null) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.$emit("creditTransactionsListModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
    showIndividualPdf(id) {
      let saleUrl = `${process.env.MIX_APP_API_ENDPOINT}/credit-transactions/pdf/${id}`;
      Utils.printPdf(saleUrl);
    },
  },
};
</script>
